module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_hearts-queen.9eed65f2.svg";